import { AccountBalance, AttachMoney, Bolt, Build, EmojiObjects, Groups, Hail, MonetizationOn, ReportProblem, Savings, SettingsInputComponent, SettingsInputSvideo, SpeakerNotes, Verified } from "@mui/icons-material"
import { AIProject, CanvasCell, CellField, CellType, LinkedRecord } from "./types"
import styles from "../Components/ProjectDetails.module.css"

export const getCanvasCells = (project: AIProject): CanvasCell[] => {
    return [
        {
            type: CellType.Text,
            fieldName: CellField.ProblemStatement,
            value: project.problemStatement,
            icon: <ReportProblem className={styles.icon} />,
        },
        {
            type: CellType.Text,
            fieldName: CellField.SolutionCallToAction,
            value: project.solution,
            icon: <Build className={styles.icon} />,
        },
        {
            type: CellType.Text,
            fieldName: CellField.Rationale,
            value: project.rationale,
            icon: <Bolt className={styles.icon} />,
        },
        {
            type: CellType.Text,
            fieldName: CellField.DataInputs,
            value: project.dataInputs,
            icon: <SettingsInputSvideo className={styles.icon} />,
        },
        {
            type: CellType.MultiSelect,
            fieldName: CellField.EndCustomers,
            value: project.endCustomers,
            icon: <Hail className={styles.icon} />,
        },

        {
            type: CellType.MultiSelect,
            fieldName: CellField.BusinessValue,
            value: project.buisinessValue,
            icon: <AccountBalance className={styles.icon} />,
        },

        {
            type: CellType.Select,
            fieldName: CellField.ExpectedBenefits,
            value: project.expectedBenefits,
            icon: <MonetizationOn className={styles.icon} />,
        },

        {
            type: CellType.Text,
            fieldName: CellField.OutputIntegration,
            value: project.output,
            icon: <SettingsInputComponent className={styles.icon} />,
        },

        {
            type: CellType.Text,
            fieldName: CellField.SuccessCriteria,
            value: project.successCriteria,
            icon: <Verified className={styles.icon} />,
        },

        {
            type: CellType.Text,
            fieldName: CellField.Notes,
            value: project.notes,
            icon: <SpeakerNotes className={styles.icon} />,
        },
    ]
}

// export const getCanvasCells = (project: AIProject): (CanvasCell | CanvasCell[])[] => {
//     return [
//         {
//             type: CellType.Text,
//             fieldName: CellField.ProblemStatement,
//             value: project.problemStatement,
//             icon: <ReportProblem className={styles.icon} />,
//         },
//         {
//             type: CellType.List,
//             fieldName: CellField.EndCustomers,
//             value: project.endCustomers,
//             icon: <Hail className={styles.icon} />,
//         },

//         {
//             type: CellType.Text,
//             fieldName: CellField.SolutionCallToAction,
//             value: project.solution,
//             icon: <Build className={styles.icon} />,
//         },

//         {
//             type: CellType.Text,
//             fieldName: CellField.Rationale,
//             value: project.rationale,
//             icon: <Bolt className={styles.icon} />,
//         },
//         {
//             type: CellType.Text,
//             fieldName: CellField.ExpectedBenefits,
//             value: project.expectedBenefits,
//             icon: <MonetizationOn className={styles.icon} />,
//         },

//         {
//             type: CellType.Text,
//             fieldName: CellField.DataInputs,
//             value: project.dataInputs,
//             icon: <SettingsInputSvideo className={styles.icon} />,
//         },
//         {
//             type: CellType.Text,
//             fieldName: CellField.OutputIntegration,
//             value: project.output,
//             icon: <SettingsInputComponent className={styles.icon} />,
//         },

//         // {
//         //     type: CellType.Select,
//         //     fieldName: CellField.Budget,
//         //     value: project.budget,
//         //     icon: <Savings className={styles.icon} />,
//         // },

//         {
//             type: CellType.List,
//             fieldName: CellField.BusinessValue,
//             value: project.buisinessValue,
//             icon: <AccountBalance className={styles.icon} />,
//         },
//         {
//             type: CellType.Text,
//             fieldName: CellField.Notes,
//             value: project.notes,
//             icon: <SpeakerNotes className={styles.icon} />,
//         },
//         {
//             type: CellType.Text,
//             fieldName: CellField.SuccessCriteria,
//             value: project.successCriteria,
//             icon: <Verified className={styles.icon} />,
//         },
//     ]
// }
